var PanelElementsElementView;

PanelElementsElementView = Marionette.ItemView.extend( {
	template: '#tmpl-kitbuilder-element-library-element',

	className: 'kitbuilder-element-wrapper',

	onRender: function() {
		var self = this;

		this.$el.html5Draggable( {

			onDragStart: function() {
				kitbuilder.channels.panelElements
					.reply( 'element:selected', self )
					.trigger( 'element:drag:start' );
			},

			onDragEnd: function() {
				kitbuilder.channels.panelElements.trigger( 'element:drag:end' );
			},

			groups: [ 'kitbuilder-element' ]
		} );
	}
} );

module.exports = PanelElementsElementView;
